import { useEffect, useState } from "react";
import LabelInput from "../../Component/labelInput";
import PageTitle from "../../module/pageTitle";
import { Submitbtn } from "../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import {
  getCategoryList,
  getProductList,
  getProductTypeList,
} from "../Admin/adminSlice";
import moment from "moment";
import DropdownWithClear from "../../Component/dropdownWithClear";
import AdminTable from "../../Component/adminTable";
// import { getCouponTypeList, getTransactionDetails } from "../cxoSlice";
import DatePicker from "../../Component/datePicker";
import { stockSellingType } from "../../Utils/dataConstant";
import { showSnackbar, hideSnackbar } from "../../store/slices/snackbarSlice";
import { getSellingSourceList } from "../Publication/publicationSlice";
import { getSellingSourceWiseAnalysis } from "./cxoSlice";
const SellingSrcRevenueAnlysis = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
 
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
    const [sellingSource, setSellingSource] = useState<any>("");
    const [sellingSourceList, setSellingSourceList] = useState<any>([]);
    const [sellingType, setSellingType] = useState<any>(""); 
    const [revenueList, setRevenueList] = useState<any>([]); 
    const [analysisList, setAnalysisList] = useState<any>([]);

  useEffect(() => {
   

    dispatch(
      getSellingSourceList({
        callback: (res: any) => {
            setSellingSourceList(res?.data);
        },
        errorCallback: () => { },
      })
    );

    const postData = {
      startDate: startDate,
      endDate: endDate,   
    };
   
   dispatch(
    getSellingSourceWiseAnalysis({
                 params: postData,
                 callback: (res: any) => {
                     setAnalysisList(res?.data);
                 },
                 errorCallback: (error: any) => {
                          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
                                setTimeout(() => {
                                  dispatch(hideSnackbar());
                                }, 5000);
                  },
             })
         );
 
  }, []);

 
 

  const onchangeSellingSource = (value: any) => {
    setSellingSource(value);
  };
  const onchangeSellingType = (value: any) => {
    setSellingType(value);

  }; 

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };
  

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      startDate: startDate,
      endDate: endDate,  
      sourceId: sellingSource?._id,
      location:sellingType?.value,
    };
   
   dispatch(
    getSellingSourceWiseAnalysis({
                 params: postData,
                 callback: (res: any) => {
                     setAnalysisList(res?.data);
                 },
                 errorCallback: (error: any) => {
                          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
                                setTimeout(() => {
                                  dispatch(hideSnackbar());
                                }, 5000);
                  },
             })
         );
 
  };

  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }
    return valid;
  };

  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={ analysisList ?  analysisList : []}
          pagename={"SellingSrcRevenueAnlysis"}
          tableHead={[
            "S.N",
            "Product Name",
            "Product Type",
            "Category",  
            "Source",
            "Amount",
            "Quantity", 
          ]}
        />
      </div>
    );
  };
  let sum: any = 0;
  for (let i = 0; i < revenueList.length; i++) {
    sum += revenueList[i].Amount;
  }
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Selling Source Revenue"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>        
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Selling Source"} />
                <DropdownWithClear
                  labelName={"Select Selling Source "}
                  setInputText={(value: any) => onchangeSellingSource(value)}
                  options={sellingSourceList}
                  value={sellingSource}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Selling Type"} />
                <DropdownWithClear
                  labelName={"Select Selling Type "}
                  setInputText={(value: any) => onchangeSellingType(value)}
                  options={stockSellingType}
                  value={sellingType}
                />
              </div> 
             
        
         
      
              <div className="col-md-4 mt-3">
                <div className="col-md-4 pt-2">
                  <Submitbtn name={"Search"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
    
        <div className="bxshadow borderRadius p-1">
          <div>{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default SellingSrcRevenueAnlysis;
